<div class="w-full h-full flex flex-col overflow-hidden">

    <nav class="bg-white w-full px-2.5 sm:px-5 py-2.5 sm:py-3 border-b flex-shrink-0" *ngIf="value !== undefined">

        <div class="flex gap-2 sm:gap-3 items-center">
            <button class="btn btn-sm btn-circle btn-ghost md:hidden" type="button" (click)="back.emit()">
                <i class="ri-arrow-left-line text-lg"></i>
            </button>
            <div class="avatar">
                <div class="w-8 sm:w-10 rounded-full">
                    <img [src]="value?.profile || defaultProfileImage"
                        alt="Tailwind-CSS-Avatar-component" />
                </div>
            </div>
            <div class="flex flex-col min-w-0 flex-1">
                <span class="font-semibold capitalize text-sm sm:text-base truncate">{{value?.name}}</span>
                <!-- <span class="text-xs text-zinc-500">{{value?.lastactive}}</span> -->
            </div>
        </div>
    </nav>

    <div *ngIf="value === undefined" class="flex-1 flex items-center justify-center bg-gray-50">
        <div class="text-center">
            <i class="ri-chat-1-line text-6xl text-gray-400 mb-4"></i>
            <h2 class="text-xl font-semibold text-gray-700 mb-2">Select a user to start chatting</h2>
            <p class="text-gray-500">Choose a conversation from the list to begin messaging.</p>
        </div>
    </div>

    <!-- message Container -->
    <div  *ngIf="value !== undefined" #messageContainer class="flex-1 min-h-0 overflow-y-auto relative px-1.5 sm:px-4 py-2 sm:py-3 bg-gray-50 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iYSIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIyMCIgZmlsbD0icmdiYSgzLDMsMywwLjAzKSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0idXJsKCNhKSIvPjwvc3ZnPg==')]">
        <div class="space-y-2 pb-2">
            <div *ngFor="let message of messages; trackBy: trackByMessageId" 
                 class="flex mb-1"
                 [ngClass]="{'justify-end': message.isSent, 'justify-start': !message.isSent}" >

                <!-- Message Bubble Container -->
                <div *ngIf="value?.id" class="flex flex-col max-w-[92%] sm:max-w-[75%] md:max-w-sm lg:max-w-md xl:max-w-lg min-w-0"
                     [ngClass]="{'items-end': message.isSent, 'items-start': !message.isSent}">

                    <!-- Message Bubble -->
                    <div class="relative min-w-0 px-2.5 sm:px-3 py-2 shadow-sm"
                         [ngClass]="{
                            'bg-gray-400':message.type === 'image',
                           'bg-[#005c4b] text-white rounded-l-2xl rounded-tr-2xl rounded-br-md': message.isSent,
                           ' text-gray-800 rounded-r-2xl rounded-tl-2xl rounded-bl-md': !message.isSent && !message.isSeen,
                           'bg-white text-gray-800 rounded-r-2xl rounded-tl-2xl rounded-bl-md': !message.isSent && message.isSeen
                         }">

                        <!-- Image Message -->
                        <div *ngIf="message.type === 'image' && message.fileUrl" class="mb-1">
                            <div class="relative group">
                                <img [src]="message.fileUrl" alt="Shared image"
                                     class="max-w-full max-h-64 rounded-lg cursor-pointer hover:opacity-90 transition-all duration-200 object-cover"
                                     (load)="scrollToBottom()"
                                     (click)="openImageModal(message.fileUrl, message.fileName)">
                                <!-- Overlay on hover -->
                                <div class="absolute inset-0 bg-black/0 group-hover:bg-black/20 rounded-lg transition-all duration-200 flex items-center justify-center opacity-0 group-hover:opacity-100">
                                    <button class="btn btn-sm btn-circle btn-ghost text-white bg-black/50 hover:bg-black/70"
                                            (click)="openImageModal(message.fileUrl, message.fileName)">
                                        <i class="ri-eye-line text-lg"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- File Message -->
                        <div *ngIf="message.type === 'file' && message.fileUrl && message.fileName"
                             class="mb-1 p-2 bg-black/10 rounded-lg">
                            <div class="flex items-center gap-2">
                                <div class="text-lg">{{ getFileIcon(message.fileName) }}</div>
                                <div class="flex-1">
                                    <p class="text-sm font-medium break-words">{{ message.fileName }}</p>
                                    <p class="text-xs opacity-75">{{ getFileSize(message.fileUrl) }}</p>
                                </div>
                                <div class="flex items-center gap-1">
                                    <!-- Preview button for supported file types -->
                                    <button *ngIf="canPreviewFile(message.fileName)"
                                            class="btn btn-xs btn-ghost text-current hover:bg-black/20"
                                            (click)="previewFile(message.fileUrl, message.fileName)"
                                            title="Preview">
                                        <i class="ri-eye-line"></i>
                                    </button>
                                    <button class="btn btn-xs btn-ghost text-current hover:bg-black/20"
                                            (click)="downloadFile(message.fileUrl, message.fileName)"
                                            title="Download">
                                        <i class="ri-download-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Text Message -->
                        <div *ngIf="message.type !== 'file' && message.type !== 'image'">
                            <p class="text-sm leading-relaxed whitespace-pre-wrap break-words break-all">{{ message.message }}</p>
                        </div>

                        <!-- Timestamp -->
                        <div class="flex items-center justify-end gap-1 mt-1">
                            <span class="text-xs opacity-75">{{(message.time) }}</span>
                            <div *ngIf="message.isSent" class="flex items-center">
                                <i class="ri-check-double-line text-xs opacity-75"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full px-2 sm:px-5 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] sm:py-3 bg-white border-t flex-shrink-0"  *ngIf="value !== undefined">
        <app-chat-input-actions></app-chat-input-actions>
    </div>
    <!-- message Container -->

</div>

<!-- Image Preview Modal -->
<div *ngIf="showImageModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-2 sm:p-4" (click)="closeImageModal()">
    <div class="relative w-full max-w-sm sm:max-w-md md:max-w-2xl lg:max-w-4xl max-h-screen" (click)="$event.stopPropagation()">
        <!-- Close button -->
        <button class="absolute top-2 right-2 btn btn-sm btn-circle btn-ghost text-white bg-black/50 hover:bg-black/70 z-10"
                (click)="closeImageModal()">
            <i class="ri-close-line text-lg sm:text-xl"></i>
        </button>

        <!-- Image container -->
        <div class="bg-white rounded-lg overflow-hidden shadow-2xl">
            <div class="relative">
                <img [src]="modalImageUrl" [alt]="modalImageName"
                     class="w-full max-h-[70vh] sm:max-h-[80vh] object-contain">
            </div>

            <!-- Image info and actions -->
            <div class="p-3 sm:p-4 bg-gray-50 border-t flex items-center justify-between">
                <div class="flex items-center gap-2 min-w-0 flex-1">
                    <i class="ri-image-line text-base sm:text-lg text-gray-600 flex-shrink-0"></i>
                    <span class="text-sm font-medium text-gray-800 truncate">{{ modalImageName }}</span>
                </div>
                <div class="flex items-center gap-2 flex-shrink-0">
                    <button class="btn btn-sm btn-ghost text-gray-600 hover:text-gray-800"
                            (click)="downloadFile(modalImageUrl, modalImageName)">
                        <i class="ri-download-line"></i>
                        <span class="hidden sm:inline ml-1">Download</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
